export default "__VITE_ASSET__DG5E7lbk__"